var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-topo-treebox"},[_c('div',{staticClass:"h-topo-tree"},[_c('ejs-treeview',{ref:"alarmTree",attrs:{"fields":_vm.getDataSource,"showCheckBox":true}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }